export const confirmSetupIntent = (): void => {/**/};
export const initStripe = (): void => {/**/};
